(function(){
  const footer = document.querySelector('footer.shopify-section-group-footer-group.section-wrapper');
  const main =
    document.querySelector('#MainContent') ||
    document.querySelector('main') ||
    document.querySelector('.content-for-layout');

  if(!footer || !main) return;

  const START_TY = 25; // percento iniziale

  function setFooterHeight(){
    const h = Math.ceil(footer.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--footer-h', h + 'px');
    return h;
  }

  function clamp(v, min, max){ return Math.min(max, Math.max(min, v)); }

  function onScroll(){
    const footerH = setFooterHeight(); // così resta corretto anche con accordion che cambia altezza
    const vh = window.innerHeight;

    const mainBottom = main.getBoundingClientRect().bottom;

    // progress: 0 quando il footer “inizia a vedersi”, 1 quando è tutto visibile
    const p = clamp((vh - mainBottom) / footerH, 0, 1);

    footer.style.transform = `translateY(${(1 - p) * START_TY}%)`;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', onScroll);
  onScroll();
})();